var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Configurações Pessoais")]),_c('v-btn',{staticClass:"ma-2",attrs:{"color":"error"},on:{"click":function($event){return _vm.$router.back()}}},[_c('v-icon',[_vm._v(" mdi-keyboard-return ")])],1),_c('colors')],1)}
var staticRenderFns = []

export { render, staticRenderFns }